//ajax
(function() {

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }



    if ($('#myModal').length) {
        $('#myModal').modal('hide');
        $('#myModal').on('hidden.bs.modal', function() {
            $('.course-list-wrap .text a.active').removeClass('active');
        });
        $('#myModal').find('.btn').click(function(e) {
            e.preventDefault();
            $activeitem = $('.course-list-wrap .text a.active');
            var productid = $activeitem.data('productid');
            var varid = $activeitem.data('id');
            var profit = 'no';
            if ($('#myModal .pricetwo ').hasClass('active')) {
                profit = 'yes';
            }

            var kiek = $('#people').val();
            var location = $activeitem.data('location');
            var date = $activeitem.data('date');
            $.ajax({
                url: ajaxurl,
                type: 'post',
                data: { action: 'cartadd', productid: productid, varid: varid, profit: profit, c: kiek, location: location, date: date },
                success: function(data) {
                    window.location.href = carturl;
                }
            });
        });
    }

    if ($('#contactform').length) {

        $('#contactform').find('.btn-orange').click(function(e) {
            e.preventDefault();
            $('#contactform').find('#email').removeClass('error');
            $('#contactform').find('.success').hide();
            $('#contactform').find('.error').hide();
            var name = $('#contactform').find('#name').val();
            organization = $('#contactform').find('#organization').val();
            jobtitle = $('#contactform').find('#job-title').val();
            email = $('#contactform').find('#email').val();
            phone = $('#contactform').find('#phone').val();
            message = $('#contactform').find('#message').val();
            if (validateEmail(email)) {
                $.ajax({
                    url: ajaxurl,
                    type: 'post',
                    data: { action: 'sendemail', name: name, organization: organization, jobtitle: jobtitle, email: email, phone: phone, message: message },
                    success: function(data) {
                        $('#contactform').find("input[type=text],input[type=email], textarea").val("");
                        $('#contactform').find('.rssp').html(data);
                    }
                });
            } else {
                $('#contactform').find('#email').addClass('err');

            }
        });

    }



    $('.course-list-wrap .text a.incartsimple').click(function(e) {
        e.preventDefault();
        var productid = $(this).data('productid');
        var kiek = 1;
        $.ajax({
            url: ajaxurl,
            type: 'post',
            data: { action: 'cartadd', productid: productid, c: kiek },
            success: function(data) {
                window.location.href = carturl;
            }
        });
    });

    $('.course-list-wrap .text a.incart').click(function(e) {
        e.preventDefault();
        $course = $(this).parents('.course-item');
        date = $course.find('.ldate').html();
        days = $course.find('.lday').html();
        locationn = $course.find('.llocation').html();
        places = $course.find('.lplaces').html();
        $('#myModal').find('.priceone .price-tag').text($(this).data('price'));
        $('#myModal').find('.pricetwo .price-tag').text($(this).data('nonprice'));
        $('#myModal').find('#modal-date').text(date);
        $('#myModal').find('#modal-days').text(days);
        $('#myModal').find('#modal-location').text(locationn);
        $('#myModal').find('#modal-price').text($(this).data('price'));
        html = '';
        for (var i = 1; i <= places; i++) {
            html = html + '<option value="' + i + '">' + i + '</option>';
        }
        //console.log(html);
        $('#myModal').find('#people option').remove();
        $('#myModal').find('#people').append(html);
        // /makeSelect();
        $(this).addClass('active');

        $('#myModal').modal('show');
    });

    $('.f-newsletter .newsletter-submit').click(function(e) {
        e.preventDefault();
        $new = $(this).parents('form');
        var email = $new.find('.newsletter-input').val();
        $new.find('.newsletter-input').removeClass('error');
        if (validateEmail(email)) {
            $.ajax({
                url: ajaxurl,
                type: 'post',
                data: { action: 'newsletter', email: email },
                success: function(data) {
                    $new.find('.newsletter-input').removeClass('error');
                    $new.find('.newsletter-input').val('');
                }
            });
        } else {
            $new.find('.newsletter-input').addClass('error');
        }
    });


    $('.shoppcart-item .icon-x').click(function(e) {
        e.preventDefault();
        var productid = $(this).data('productid');
        var varid = $(this).data('id');
        var profit = $(this).data('profit');
        var location = $(this).data('location');
        var date = $(this).data('date');
        $.ajax({
            url: ajaxurl,
            type: 'post',
            data: { action: 'removefromcart', productid: productid, varid: varid, profit: profit, location: location, date: date },
            success: function(data) {
                $('.total-price .big').html(data);
            }
        });

        $(this).parents('.shoppcart-item').fadeOut('fast', function() {
            $(this).remove();
        });
    });


    $('#inh').click(function(e) {
        e.preventDefault();
        err = false;
        if (!$('#course').val()) {
            err = true;
            $('#course').addClass('error');
        }
        if (!$('#name').val()) {
            err = true;
            $('#name').addClass('error');
        }
        if (!$('#email').val()) {
            err = true;
            $('#email').addClass('error');
        }
        if (!$('#organization').val()) {
            err = true;
            $('#organization').addClass('error');
        }
        if (!$('#contactnumber').val()) {
            err = true;
            $('#contactnumber').addClass('error');
        }

        if (err === false) {
            $('.tab .tab1').fadeOut(400, function() {
                $('.tab .tab2').fadeIn(400, function() {

                });
            });
        }
    });


    $('#inhsubmit').click(function(e) {
        e.preventDefault();
        err = false;
        course = $('#course').val();
        var name = $('#name').val();
        email = $('#email').val();
        organization = $('#organization').val();
        contactnumber = $('#contactnumber').val();

        if (!$('#who').val()) {
            who = '';
           //$('#who').addClass('error');
        } else {
            who = $('#who').val();
        }

        if (!$('#what').val()) {
            what = '';
           // $('#what').addClass('error');
        } else {
            what = $('#what').val();
        }

        if (!$('#how').val()) {
            how = '';
          //  $('#how').addClass('error');
        } else {
            how = $('#how').val();
        }

        if (!$('#when').val()) {
            when = '';
            //$('#when').addClass('error');
        } else {
            when = $('#when').val();
        }

        if (!$('#didu').val()) {
            didu = '';
           //$('#didu').addClass('error');
        } else {
            didu = $('#didu').val();
        }

        if (!$('#wasit').val()) {
            wasit = '';
           // $('#wasit').addClass('error');
        } else {
            wasit = $('#wasit').val();
        }
        if (err === false) {
            $.ajax({
                url: ajaxurl,
                type: 'post',
                data: { action: 'sendinhousetraining', course: course, name: name, email: email, organization: organization, contactnumber: contactnumber, who: who, what: what, how: how, when: when, didu: didu, wasit: wasit },
                success: function(data) {
                    $('.tab .tab2').fadeOut(400, function() {
                        $('.tab .tab1').fadeIn(400, function() {
                            $('.form').find("input[type=text],input[type=email], textarea").val("");
                            $('.rspinhtr').html(data);
                        });
                    });
                }
            });
        }
    });

    $('.morecurses').click(function(e) {
        e.preventDefault();
        c = $('.ajaxrspn .course').length;
        term = $(this).data('term');
        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: "json",
            data: { action: 'morecurses', offset: c, term: term },
            success: function(data) {
                if (data.html) {
                    $('.ajaxrspn').append(data.html);
                    if (data.count !== 8) {
                        $('.morecurses').hide();
                    }
                } else {
                    $('.morecurses').hide();
                }
            }
        });
    });

    $('.moretestimonials').click(function(e) {
        e.preventDefault();
        c = $('.ajaxrspn .testimonial').length;
        term = $(this).data('term');
        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: "json",
            data: { action: 'moretestimonials', offset: c, term: term },
            success: function(data) {
                if (data.html) {
                    $('.ajaxrspn').append(data.html);
                    if (data.count !== 7) {
                        $('.moretestimonials').hide();
                    }
                } else {
                    $('.moretestimonials').hide();
                }
            }
        });
    });

    $('.morenews').click(function(e) {
        e.preventDefault();
        c = $('.ajaxrspn .news-item').length;
        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: "json",
            data: { action: 'morenews', offset: c },
            success: function(data) {
                if (data.html) {
                    $('.ajaxrspn').append(data.html);
                    if (data.count !== 6) {
                        $('.morenews').hide();
                    }
                } else {
                    $('.morenews').hide();
                }
            }
        });
    });



    $('#tab1 .detail-btn').click(function(e) {
        e.preventDefault();
        var er = false;
        $('#tab1 .input-text ').not('#billing_address_2,#billing_address_3').each(function(index, el) {
            if (!$(el).val()) {
                er = true;
                $(el).addClass('error');
            } else {
                $(el).removeClass('error');
            }
        });
        if (er === false) {
            $('#tab1').fadeOut(400, function() {
                $('.step2').addClass('active');
                $('#tab2').fadeIn(400);
            });
        }
    });

    $('#tab2 .detail-btn').click(function(e) {
        e.preventDefault();
        var er = false;
        $('#tab2 .input ').each(function(index, el) {
            if (!$(el).val()) {
                er = true;
                $(el).addClass('error');
            } else {
                $(el).removeClass('error');
            }
        });
        if (!$('#tab2 #terms').is(':checked')) {
            er = true;
            $('#tab2 .ic').addClass('error');
        } else {
            $('#tab2 .ic').removeClass('error');
        }

        if (er === false) {
            var text = '';
            $('.woocommerce-shipping-fields .acc>.item').each(function(index, el) {

                var coursetitle = $(el).find('h2').text();
                text = text + coursetitle + '\n';
                $(el).find('.dalyvis').each(function(index, el) {
                    text = text + $(el).find('h3 span').text() + '\n';
                    text = text + 'First Name:' + $(el).find('.fname').val() + '\n';
                    text = text + 'Last Name:' + $(el).find('.lname').val() + '\n';
                    text = text + 'Organisation:' + $(el).find('.organization').val() + '\n';
                 //   text = text + 'Telephone:' + $(el).find('.telephone').val() + '\n';
                    text = text + 'Email:' + $(el).find('.email').val() + '\n';
                });
                text = text + '\n\n';
            });
            $('#order_comments').val(text);
            $('#tab2').fadeOut(400, function() {
                $('.step3').addClass('active');
                $('#tab3').fadeIn(400, function() {
                    $('#tab3 .pay-method').click(function(e) {
                        e.preventDefault();
                        $('.pay-method').removeClass('active');
                        $(this).addClass('active');
                        $(this).find('.input-radio').prop("checked", true);
                    });
                });
            });
        }

    });

    $('.filterloaction a').click(function(e) {
        e.preventDefault();
        $('.filterloaction li').removeClass('active');
        $(this).parent('li').addClass('active');
        var loc = $(this).data('location');
        var day = $('.filterdays .active a').data('day');
        filtercourse(loc, day);

    });

    $('.filterdays a').click(function(e) {
        e.preventDefault();
        $('.filterdays li').removeClass('active');
        $(this).parent('li').addClass('active');
        var day = $(this).data('day');
        var loc = $('.filterloaction .active a').data('location');
        filtercourse(loc, day);

    });

    function filtercourse(loc, day) {
        $('.course-item').removeClass('active').hide();
        var c1 = '.filterloc' + loc;
        var c2 = '.filterday' + day;
        if (loc === 'all') {
            c1 = '';
        }
        if (day === 'all') {
            c2 = '';
        }
        $('.course-item' + c1 + c2).addClass('active').show();
        $('.course-list-wrap').each(function(index, el) {
            if (!$(el).find('.course-item.active').length) {
                $(el).hide();
            } else {
                $(el).show();
            }
        });
    }


    $('.clients-sort a').not('.tetsfilter').click(function(e) {
        e.preventDefault();
        //console.log('f');
        $('.clients-sort li').removeClass('active');
        $(this).parent('li').addClass('active');
        $('.clients-list-top .i-client').hide();
        $('.clients-list li').hide();

        f = $(this).data('cat');
        $('.clients-list-top .' + f).show();
        $('.clients-list .' + f).show();
    });

    $('.copyinfo').click(function(e) {
        e.preventDefault();
        var name = $('#billing_first_name').val();
        var lastname = $('#billing_last_name').val();
        var billing_company = $('#billing_company').val();
        var billing_phone = $('#billing_phone').val();
        var billing_email = $('#billing_email').val();
        var $d = $(this).parents('.dalyvis');
        $d.find('.fname').val(name);
        $d.find('.lname').val(lastname);
        $d.find('.organization').val(billing_company);
        $d.find('.telephone').val(billing_phone);
        $d.find('.email').val(billing_email);
    });
    $('.pay-method .selectm').click(function(e) {
        setTimeout(function() { $('.woocommerce-checkout #place_order').click(); }, 100);
    });


})();
